module.exports = __webpack_public_path__ + "static/img/stshopcC.3a6fa62.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/stshopcC.png
// module id = T23Y
// module chunks = 1